export const CDN_BASE = 'https://noma-template.cdn.modulify.website'

export const img = (file: string): string => `${CDN_BASE}/images/${file}`
export const vid = (file: string): string => `${CDN_BASE}/video/${file}`

/* The four frames the hero dissolves between, in slide order.
   Set by hand — do not swap these out. */
export const heroSlides = [
    { src: img('hero-orange-frame.png'), alt: 'A portrait framed through a slab of orange acrylic' },
    { src: img('hero-wide-studio.png'), alt: 'A wide studio scene lit from one side' },
    { src: img('hero-portrait-pair.png'), alt: 'A close studio portrait in warm light' },
    { src: img('hero-tall-figure.png'), alt: 'A full-length figure against a plain wall' }
]

export const media = {
    /* Lead frame for each portfolio piece, keyed by its slug. */
    projectShots: {
        vantra: img('project-vantra.jpg'),
        lume: img('project-lume.jpg'),
        kestrel: img('project-kestrel.jpg'),
        baseline: img('project-baseline.jpg'),
        meridian: img('project-meridian.jpg'),
        forge: img('project-forge.jpg')
    },

    /* Two supporting frames per project, shot to its own industry. This used to
       be a shared pool of four, which meant all six galleries showed the same
       pictures in a different order. */
    projectShoots: {
        vantra: [img('shot-vantra-a.jpg'), img('shot-vantra-b.jpg')],
        lume: [img('shot-lume-a.jpg'), img('shot-lume-b.jpg')],
        kestrel: [img('shot-kestrel-a.jpg'), img('shot-kestrel-b.jpg')],
        baseline: [img('shot-baseline-a.jpg'), img('shot-baseline-b.jpg')],
        meridian: [img('shot-meridian-a.jpg'), img('shot-meridian-b.jpg')],
        forge: [img('shot-forge-a.jpg'), img('shot-forge-b.jpg')]
    },

    /* The old shared pool. Kept because the frames are still on the CDN, but
       nothing draws from it now that every project has its own two shots. */
    workPool: {
        product: img('work-product.jpg'),
        model: img('work-model.jpg'),
        material: img('work-material.jpg'),
        motion: img('work-motion.jpg')
    },

    people: {
        /* Set by hand on the about card — do not swap. */
        founderCard: img('about-founder-portrait.png'),
        founderAvatar: img('team-jin.jpg'),
        avatarTwo: img('team-alex.jpg'),
        avatarThree: img('avatar-one.jpg'),
        contactPill: img('team-jin.jpg'),
        rating: [
            img('team-sarah.jpg'),
            img('team-alex.jpg'),
            img('avatar-one.jpg')
        ]
    },

    work: {
        /* The seven frames behind the pinned zoom-out, keyed to the cell shape
           each one is cropped into. Set by hand — do not swap these out. */
        mosaic: {
            portraitStudio: img('work-portrait-studio.png'),
            wideOne: img('work-wide-one.png'),
            tallFigure: img('work-tall-figure.png'),
            eyeCloseUp: img('work-eye-closeup.png'),
            streetStyle: img('work-street-style.jpg'),
            tallHero: img('hero-tall-figure.png'),
            wideTwo: img('work-wide-two.png')
        }
    },

    /* Editorial and studio frames used to break up the text-only sections. */
    editorial: {
        denim: img('editorial-denim.jpg'),
        silver: img('editorial-silver.jpg'),
        workspace: img('workspace-sketches.jpg'),
        texture: img('texture-leather.jpg'),
        interior: img('studio-interior.jpg'),
        catalogs: img('review-catalogs.jpg'),
        flatLay: img('flat-lay-tools.jpg'),
        /* Set by hand — do not swap. The moodboard sits in Principles and the
           book spread in Awards, both chosen against the cobalt. */
        moodboard: img('studio-moodboard.png'),
        bookSpread: img('studio-book-spread.png'),
        deskLight: img('studio-desk-light.png'),
        floorWide: img('studio-floor-wide.png')
    },

    clientPortraits: [
        img('portrait-client-one.jpg'),
        img('portrait-client-two.jpg'),
        img('portrait-client-three.jpg')
    ],

    callout: img('callout-texture.jpg'),
    /* The studio page shows all four of these at once, so each slot gets its
       own frame rather than repeating one across the section. */
    teamPhoto: img('studio-hero.jpg'),
    studioHero: img('studio-culture.jpg'),
    studioCulture: img('studio-interior.jpg'),
    studioWide: img('studio-wide.jpg'),

    video: {
        projectVantra: vid('project-vantra.mp4'),
        projectKestrel: vid('project-kestrel.mp4'),
        reelClip: vid('iZPuLK0vXt8CCy2noI8wC0FEz8.mp4'),
        motionClip: vid('w6hIDNoAdG3rSlPxSdrw8mLiU.mp4'),
        mosaicOne: vid('zk4QwPEBf55qHWWuzSLnDdW3k.mp4'),
        mosaicTwo: vid('C9XmxGlI7CHM3fP1IrUdFQc.mp4')
    }
}
